PES = PES || {}
PES.TrialModal = function () {
    PES.emailValidation =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    PES.scrollPosHidingPopup = 100;
    var registerUserForTrial = function () {
        $("#submitPlanviewRequest").on("click", function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            tryForFreePost();
        });
        $(".trial-email").on('keyup', function (e) {
            if (e.keyCode == 13) {
                tryForFreePost();
            }
        });
        function tryForFreePost() {
            var email = $(".trial-email").val();
            if (PES.emailValidation.test(String(email).toLowerCase())) {
                $(".try-for-free-txt").addClass("inactive");
                $(".try-for-free").attr("disabled", "disabled");
                $(".loading-gif").removeClass("inactive");

                $.ajax({
                    type: "POST",
                    url: $(".try-for-free").attr("data-url"),
                    data: { email: email },
                    success: function (response) {
                        setTimeout(function () {
                            $(".try-for-free").removeAttr("disabled");
                            $(".loading-gif").addClass("inactive");

                            $(".try-for-free-txt").removeClass("inactive");
                        }, 100);

                        if (response.trialUserExists) {
                            showErrorMessage(".trial-email", $(".trial-email").attr("data-used-email"));
                        } else if (!response.isEmailValid) {
                            showErrorMessage(".trial-email", $(".trial-email").attr("data-invalid-email"));
                        } else {
                            $(".trust-pilot-content").addClass("hidden");
                            $(".planview-form").css("display", "none");
                            $(".enrolment-confirmation").removeClass("hidden");
                        }
                    }
                });
            } else {
                showErrorMessage(".trial-email", $(".trial-email").attr("data-invalid-email"));
            }
        }

        function showErrorMessage(element, errorMessage) {
            $(element).first().popover({
                content: errorMessage,
                placement: "top",
                trigger: "manual"
            }).popover("show");

            $("body").on('click', function (e) {
                if (!$(e.target).hasClass("popover") && !$(e.target).hasClass("try-for-free") && $(".popover").length > 0) {
                    $(".popover").popover("dispose");
                }
                $("body").off('click');
            });

            $(".trial-email").on("onkeydown",
                function() {
                    if ($(".popover").length > 0) {
                        $(".popover").popover("dispose");
                    }
                });
        }

        setTimeout(function() {
            $(".loading-gif").html($(".try-for-free").attr("data-loading-text"));
        },500);
    }


    var handlePopUpDisplay = function () {
        var startWindowScroll = $(window).scrollTop();

        if (startWindowScroll > PES.scrollPosHidingPopup) {
            $(".new-banner.scroll-y").removeClass("hide-popup");
        } 

        $(window).scroll(function () {
            var scroll = $(window).scrollTop();

            if (scroll >= PES.scrollPosHidingPopup) {
                $(".new-banner.scroll-y").removeClass("hide-popup");
            } else {
                $(".new-banner.scroll-y").addClass("hide-popup");
            }
        });
    }

    var init = function () {
        registerUserForTrial();
        handlePopUpDisplay();
    }

    return {
        init: init
    }
}